import { CobranzasAxios, COMPANY } from './config'

export const postActivities = async (data) => {
  const res = await CobranzasAxios.post(`/activity/${COMPANY}`, data)
  return res.data
}

export const importActivities = async (data) => {
  const res = await CobranzasAxios.post(`/activity/import/${COMPANY}`, data)
  return res.data
}

export const getActivities = async () => {
  const res = await CobranzasAxios.get(`/activity/${COMPANY}`)
  return res.data
}

export const putActivities = async (data, id) => {
  const res = await CobranzasAxios.put(`/activity/${id}`, data)
  return res.data
}
